import { createSlice } from "@reduxjs/toolkit";
import { setAuthToken as syncSetAuthToken, clearAuthToken as syncClearAuthToken } from "../../utils/authSync";
import { clearAuthCookies } from "../../utils/authCookie";
import { cancelPendingAuthRedirect } from "../../utils/http.utils";

const initialState = {
  userData: {},
  aiStatus: false,
  authToken: undefined,
  tenantLabel: undefined,
};

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    storeAuthToken: (state, action) => {
      const payload =
        typeof action.payload === "object" && action.payload !== null
          ? action.payload
          : { token: action.payload, keepSignedIn: true };

      // Use the authSync utility to handle cross-tab synchronization
      if (payload.token) {
        cancelPendingAuthRedirect();
      }
      syncSetAuthToken(payload.token, payload.keepSignedIn);
      state.authToken = payload.token;
    },
    storeUserData: (state, action) => {
      state.userData = action.payload;
    },
    storeAiStatus: (state, action) => {
      state.aiStatus = action.payload;
    },
    clearProfileState: (state) => {
      // Use the authSync utility to handle cross-tab synchronization
      syncClearAuthToken();
      clearAuthCookies();
      localStorage.removeItem("tenantSetupCompleted");
      localStorage.removeItem("tutorialComplete");
      // localStorage.removeItem("slug");
      sessionStorage.clear(); // Clear chat history and other session data
      state.authToken = undefined;
      state.userData = {};
    },
  },
});

export const {
  storeAuthToken,
  storeAiStatus,
  storeUserData,
  clearProfileState,
} = profileSlice.actions;

export const logout = () => (dispatch) => {
  dispatch(clearProfileState());
  // Reset date range to default
  dispatch({ type: 'dateRange/resetDateRange' });
};

export default profileSlice.reducer;
